'use strict';

angular.module('amexReconciliationApp')
  .directive('removeCommas',
  function removeCommas() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elem, attrs, ngModel) {
        ngModel.$parsers.push(function(value) {
          return parseFloat(String(value).replace(/[,]/g, ''));
        });
      }
    };
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/removeCommas.js
// module id = 533
// module chunks = 0